import React from "react";
import "../Styles/Footer.css";
import {
  BsMessenger,
  BsGeoAltFill,
  BsWhatsapp,
  BsEnvelopeFill,
} from "react-icons/bs";
import { Link } from "react-router-dom";
import SocialIcons from "./SocialIcons";
import BookNowCTA from "./BookNowCTA";
import packageJson from "../../package.json";

function Footer() {
  // WhatsApp link target - phone number is intentionally NOT shown to
  // visitors; it is only used inside the wa.me deep link.
  const phoneNumber = "+306946162665";
  const url = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(" ")}`;

  // WhatsApp icon is shown on mobile devices only.
  const isMobile =
    typeof navigator !== "undefined" &&
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

  return (
    <footer className="footer" role="contentinfo">
      <div className="footer_content">
        {/* Contact */}
        <div className="footer_section">
          <h3 className="footer_titles">
            <span className="footer_titles__eyebrow">Reach us</span>
            Contact
          </h3>
          <div className="footer_contact_icons">
            <a
              href="https://m.me/332846666816250"
              target="_blank"
              rel="noopener noreferrer"
              className="footer_icon_btn"
              aria-label="Message us on Messenger"
              title="Messenger"
            >
              <BsMessenger className="footer_buttons" size={22} />
            </a>
            <BookNowCTA variant="footer" />
            {isMobile && (
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="footer_icon_btn"
                aria-label="Chat with us on WhatsApp"
                title="WhatsApp"
              >
                <BsWhatsapp className="footer_buttons" size={22} />
              </a>
            )}
          </div>
          <a className="footer__email" href="mailto:info@oldhouse.gr">
            <BsEnvelopeFill size={14} />
            info@oldhouse.gr
          </a>
        </div>

        {/* Find us */}
        <div className="footer_section">
          <h3 className="footer_titles">
            <span className="footer_titles__eyebrow">Visit</span>
            Find us
          </h3>
          <Link
            to="/findus"
            className="footer_icon_btn"
            aria-label="Open the Find us page"
            title="Find us"
          >
            <BsGeoAltFill className="footer_buttons" size={22} />
          </Link>
          <p style={{ margin: 0, fontSize: "0.875rem", opacity: 0.85 }}>
            Afantou village, Rhodes
          </p>
        </div>

        {/* Follow */}
        <div className="footer_section">
          <h3 className="footer_titles">
            <span className="footer_titles__eyebrow">Follow</span>
            Social
          </h3>
          <SocialIcons />
        </div>
      </div>

      <div className="footer__bottom">
        <span className="vintage-mark">The Old House</span>
        <span className="footer__sep">·</span>
        <span>Afantou, Rhodes</span>
        <span className="footer__sep">·</span>
        <span>Since 1986</span>
        <span className="footer__sep">·</span>
        <Link to="/privacy" className="footer__legal">
          Privacy
        </Link>
        <span className="footer__sep footer__sep--powered">·</span>
        <span className="footer__powered">
          Powered by{" "}
          <a
            href="https://rhodian.gr"
            target="_blank"
            rel="noopener noreferrer"
          >
            Rhodian.gr
          </a>
          <span className="footer__version">v{packageJson.version}</span>
        </span>
      </div>
    </footer>
  );
}

export default Footer;
